// Elv3FormField.jsx
import React from "react";
import { Box } from "@mui/material";
import DOBProfile from "./DOBProfile";

// Mapping function: converts the raw profile from DOBProfile into the proper shape
// for the given section.
const mapProfileForSection = (sectionName, profile) => {
  switch (sectionName) {
    case "ApplicantInformation":
      return {
        ApplicantGuid: profile.contactGuid || "",
        BusinessAddress: profile.Street || "",
        BusinessFax: profile.BusinessFax || null,
        BusinessName: profile.businessName || "",
        BusinessTelephne: profile.businessPhone || "",
        City: profile.city || "",
        Email: profile.email || "",
        FirstName: profile.firstName || "",
        FullName: profile.fullname || "",
        LastName: profile.lastName || "",
        Mobile: profile.mobile || "",
        MI: profile.middleName || "",
        State: profile.state || "",
        Zip: profile.zip || "",
      };

    case "OwnerInformation":
      return {
        BusinessName: profile.businessName || "",
        BusinessPhone: profile.businessPhone || "",
        City: profile.city || "",
        ContactGuid: profile.contactGuid || "",
        Email: profile.email || "",
        FirstName: profile.firstName || "",
        Fullname: profile.fullname || "",
        LastName: profile.lastName || "",
        MiddleName: profile.middleName || "",
        Mobile: profile.mobile || "",
        OwnerType: profile.ownerType || "",
        State: profile.state || "",
        Street: profile.street || "",
        Zip: profile.zip || "",
        LicenseList:
          profile.licenseList && profile.licenseList.length > 0
            ? profile.licenseList
            : [],
      };

    case "PerformingAgencyDirectorInformation":
    case "PerformingAgencyInspectorInformation":
    case "PerformingMaintenanceDirectorInformation": {
      // For these roles, we need additional license details.
      const chosenLicense =
        profile.licenseList && profile.licenseList.length > 0
          ? profile.licenseList[0]
          : null;
      return {
        BusinessName: profile.businessName || "",
        BusinessPhone: profile.businessPhone || "",
        City: profile.city || "",
        ContactGuid: profile.contactGuid || "",
        Email: profile.email || "",
        FirstName: profile.firstName || "",
        Fullname: profile.fullname || "",
        LastName: profile.lastName || "",
        MiddleName: profile.middleName || "",
        Mobile: profile.mobile || "",
        OwnerType: profile.ownerType || "",
        State: profile.state || "",
        Street: profile.street || "",
        Zip: profile.zip || "",
        LicenseList:
          profile.licenseList && profile.licenseList.length > 0
            ? profile.licenseList
            : [],
        LicenseLookUpDetails: chosenLicense || {},
        CertificationNumber: chosenLicense
          ? chosenLicense.CertificationNumber || ""
          : "",
        LicenseGuid: chosenLicense ? chosenLicense.LicenseeGuid || "" : "",
        LicenseNumber: chosenLicense ? chosenLicense.LicenseNumber || "" : "",
        BadgeNumber: chosenLicense ? chosenLicense.BadgeNumber || null : null,
      };
    }
    default:
      return profile;
  }
};

const Elv3FormField = ({ sectionName, onProfileConfirmed, dobProfiles }) => {
  // This callback is triggered by DOBProfile once the user confirms the profile.
  const handleProfileConfirmed = (profile) => {
    const mappedProfile = mapProfileForSection(sectionName, profile);
    if (onProfileConfirmed) {
      onProfileConfirmed(sectionName, mappedProfile);
    }
  };

  return (
    <Box mb={2}>
      <DOBProfile
        onProfileConfirmed={handleProfileConfirmed}
        sectionName={sectionName}
        profiles={dobProfiles} // Pass the pre-fetched profiles here
      />
    </Box>
  );
};

export default Elv3FormField;
